<template>
  <section class="navbar-box">
    <div class="container">
      <ul
        class="nav"
        v-if="courseCategories.length"
      >
        <li
          v-for="category in courseCategories"
          :key="category.id"
          class="nav__item"
        >
          <button
            class="nav__link"
            @click="clickMenuItem(category)"
          >
            <div v-html="category.svg"></div>
            {{ category.name }}
          </button>

          <span
            v-if="category.categories.length"
            class="nav__arrow"
          ></span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    computed: {
      ...mapGetters('courseCategory', ['courseCategories']),
    },

    watch: {
      courseCategories () {
        this.$nextTick(() => this.$emit('loaded'))
      }
    },

    methods: {
      ...mapActions('slideSidebar', ['slideSidebarToggle']),

      clickMenuItem (category) {
        if (!category.categories.length) {
          this.$router.push(category.url)
        } else {
          this.slideSidebarToggle({
            name: 'CategoriesSubNavbarSidebar',
            direction: 'left',
            props: { category }
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  // .navbar-box {
    // border-top: 1px solid rgba(#000, .07);
    // border-bottom: 1px solid rgba(#000, .1);
  // }

  .nav {
    $p: &;

    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    flex-direction: column;
    border: 0;

    &__link {
      position: relative;
      display: flex;
      width: 100%;
      align-items: center;
      padding: 12px 0;
      color: rgba(#000, .8);
      font-size: 0.89rem;
      border-top: 2px solid transparent;
      border-bottom: 2px solid transparent;

      &:after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 0%;
        height: 2px;
        background-color: transparent;
        transition: .5s all;
      }

      div {
        margin-right: 10px;
        width: 27px;
        height: 27px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 25%;

        ::v-deep svg {
          width: 16px;
          fill: #fff;
        }
      }
    }

    &__item &__link {
      color: var(--color);
      font-size: 0.89rem;
      padding: 1rem 0;
      border: 0;
      transition: .5s all;

      div {
        border: 1px solid transparent;
        transition: .5s all;
        background: var(--color);

        ::v-deep svg { fill: #fff; transition: .5s all }
      }
    }

    &__item {
      position: relative;
      transition: .5s all;
    }

    &__arrow {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(50%);
      border: solid rgba(#000, .175);
      border-width: 0 3px 3px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
  }
</style>